// router.pathname 은 Next.js Pages Router의 라우트 템플릿이라 동적 세그먼트가
// 값이 아닌 대괄호 그대로 온다(예: 실제 URL '/play/abc' → pathname '/play/[entryMapHashId]').

// 전역 게이트(_app)로 옮기기 전(#3592, 2026-08)까지 이 모달은 세 페이지 컴포넌트가
// 직접 호출했다 — MyQuizPage(/myquiz)·PublicPageView(/public)·LandingPageView.
// LandingPageView 는 `/` 와 `/landing` 두 라우트가 같이 렌더하므로 둘 다 포함한다.
//
// 제외 목록이 아니라 허용 목록인 이유: 게이트가 전역이라 기본값이 "뜸" 이면 새로
// 추가되는 모든 페이지가 자동으로 노출 대상이 된다. 기본값을 "안 뜸" 으로 뒤집어
// 노출하려는 페이지만 여기에 적는다.
// 네 경로 모두 하위 라우트가 없어 정확일치로 충분하다.
const ALLOWED_PATHNAMES = ['/', '/landing', '/myquiz', '/public'];

export const isPhoneVerificationPromptRouteEligible = ({
  isInExternalPlatform,
  pathname,
}: {
  isInExternalPlatform: boolean;
  pathname: string;
}) => !isInExternalPlatform && ALLOWED_PATHNAMES.includes(pathname);
